<h2 mat-dialog-title>GWC Regalia Hire Terms & FAQ</h2>

<mat-dialog-content>

    <div class="font-medium mb-8">
        Congratulations and thank you for hiring with us. We are a registered charity, profits from regalia hire go towards student scholarships, so you are helping your fellow students!
    </div>

    <div class="font-medium">PREMISES</div>
    <div class="font-normal mb-8">
        The easiest way to find us is to Google us. We are on UC Dovedale Campus and don’t have a physical number. Google has images showing our main entrance to help make this easy for you. There is carparking available in Car Park 2 off Solway Ave.
    </div>

    <div class="font-medium">RETURN</div>
    <div class="font-normal mb-8">
        Anyone can return the regalia to our premises. Please note: we are not open outside of the days and times stipulated on your order.  You CANNOT leave the regalia anywhere else on campus.
        <br><br>
        If there is no damage to the regalia, you will be advised that the regalia has been checked for damage and no further communication should be required.
        <br><br>
        Regalia DOES NOT LEAVE the province of Canterbury unless a prior arrangement is made.
    </div>

    <div class="font-medium">OUTSTANDING REGALIA RETURN PROCESS</div>
    <div class="font-normal mb-8">
        Any regalia not returned at the times stipulated will automatically incur a $50 late return charge if no arrangement has been made. There are no excuses! A reminder text will be sent for outstanding regalia. If regalia has still not been returned, an invoice for the full replacement cost of the regalia will be sent. This will also apply to any damaged regalia.
        <br><br>
        If the regalia has still not been returned or paid for after the payment due date, a 48-hour final notice will be sent.
        <br><br>
        In the case we need to employ the services of the credit agency, Undercontrol Credit Management, you are liable for the agency and/or legal costs incurred to recover the outstanding amount/s.
    </div>


    



    
    <div class="font-medium">CAN'T COLLECT YOUR OWN REGALIA?</div>

    <div class="font-normal mb-8">
        Please give the person collecting for you your FULL HEIGHT and HEAD CIRCUMFERENCE measured just above your ears, IF you are eligible for a hat.   
        The measurement should in the 50cms or low 60cm’s. 
        This is a guideline only and the hat may still be an incorrect fit.
        <br><br>
        Regalia DOES NOT LEAVE the province of Canterbury unless a prior arrangement is made.
    </div>

    <div class="font-medium">LOSS OR DAMAGE TO REGALIA</div>
    <div class="font-normal mb-8">
        1.	Hats are not to be thrown, the corners are fragile and cannot be repaired. 
        2.	Regalia is to be kept dry, due to the fabrics; excessive rain can cause damage to regalia including the hats.
        3.	Badly soiled regalia will result in a cleaning fee, which you will be advised. 
        4.	If there is any permanent damage to any item of regalia that is beyond repair, or the item is lost for more than a month, the following replacement costs are: 
        Hat $150
        Hood/Stole $100-$350
        Gown $650
        <br>
        An invoice will be issued, and a payment plan can be agreed upon with the discretion of GWC Regalia Hire’s Manager.
    </div>

    <div class="font-medium">REFUNDS</div>
    <div class="font-normal mb-8">
        In the event you do not collect your regalia and do not advise us, there are no refunds and a credit will be kept for you to use at another convenient time.
        <br><br>
        If you are ill for any reason (including isolating for COVID-19) and you have advised us, you can choose to leave the order in credit to use at another suitable time or we can refund less any items we have had to order in ie: other tertiary institutions regalia.
    </div>

    <div class="font-normal mb-8">
        Thank you,
        <br>
        GWC Regalia Hire
    </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close cdkFocusInitial>OK</button>
</mat-dialog-actions>